import { uniqBy } from 'lodash';

// only for rental-browser
const getUniqFormattedData = (array, key) => {
  let dataToFormat = array;
  dataToFormat.forEach(list => {
    list.rental_house = [];
    dataToFormat.forEach(house => {
      if (list.name === house.name) {
        list.rental_house.push({
          isCompletedProject: house.isCompletedProject,
          name: house.title,
          price: house.price,
          bed: house.bed,
          bath: house.bath,
          image: house.rental_image,
          rental_home_url_slug: house.rental_home_url_slug,
          projectSlug: house.projectSlug,
          productSlug: house.productSlug,
          postFix: house.postFix,
        });
      }
    });
  });

  return uniqBy(dataToFormat, key);
};

export const ArrayUtil = {
  getUniqFormattedData,
};
